import React from 'react'
import DimensionBadge from '../../common/dimension-badge'

const DimensionPills = ({ dimensions = []}) => {
    return (
        <div style={{

        }}>
            {dimensions.map((d,k) => <DimensionBadge key={k} dimensionId={d} />)}
        </div>
    )
}

export default DimensionPills